import defineComponent from 'flight';
import $ from 'static/script/libs/jquery';

function DeferLoad() {
    this.defaultAttrs({
        deferImages: '[data-defer-image]',
        deferImageBreakpoint: 'data-defer-breakpoint'
    });

    this._loadImages = function (evt, payload) {
        this.select('deferImages').each(function () {
            let $el = $(this);
            let imageBreakpoint = $el.data('defer-breakpoint');
            if (payload[imageBreakpoint] === true) {
                $el.replaceWith($el.text());
            }
        });
    };

    this.after('initialize', function () {
        this.on(document, 'utils:window-resize:resized ui:navigation:after-page-change', this._loadImages);
    });
}

module.exports = defineComponent.component(DeferLoad);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/defer-load.js